import request from "@/utils/request";

export function shoppingDetail(params) {
  return request({
    url: "/trade/shopping/flash",
    method: "get",
    params,
  });
}

//直接购买接口省去了调shoppingDetail的步骤
export function purchaseDirect(data) {
  return request({
    url: "/trade/shopping/flash/direct",
    method: "post",
    data,
  });
}
export function purchaseSuiteDirect(data) {
  return request({
    url: "/trade/shopping/suite/confirm",
    method: "post",
    data,
  });
}
export function calcOrder(data) {
  return request({
    url: "/trade/shopping/calc",
    method: "post",
    data,
  });
}
export function calcSuiteOrder(data) {
  return request({
    url: "/trade/shopping/suite/calc",
    method: "post",
    data,
  });
}
export function submitOrder(data) {
  return request({
    url: "/trade/shopping/order",
    method: "post",
    data,
  });
}
export function submitSuiteOrder(data) {
  return request({
    url: "/trade/shopping/suite/commit",
    method: "post",
    data,
  });
}
// 抽中商品下单
export function purchaseAwardDirect(params) {
  return request({
    url: "/trade/shopping/award/confirm",
    method: "post",
    params,
  });
}
export function calcAwardOrder(params) {
  return request({
    url: "/trade/shopping/award/calc",
    method: "post",
    params,
  });
}
export function submitAwardOrder(params) {
  return request({
    url: "/trade/shopping/award/commit",
    method: "post",
    params,
  });
}
export function purchaseFreeGoodsDirect(params) {
  return request({
    url: "/trade/shopping/free-goods/confirm",
    method: "post",
    params,
  });
}
export function calcFreeGoodsOrder(params) {
  return request({
    url: "/trade/shopping/free-goods/calc",
    method: "post",
    params,
  });
}
export function submitFreeGoodsOrder(params) {
  return request({
    url: "/trade/shopping/free-goods/commit",
    method: "post",
    params,
  });
}
